import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TrackingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        // Swallow tracking endpoint errors to avoid unhandled promise rejections in UI
        const isTracking = typeof req.url === 'string' && /\/v1\/tracking\/?$/i.test(req.url);
        if (isTracking) {
          // Optional: log once in console
          // eslint-disable-next-line no-console
          console.warn('Tracking endpoint error silenced:', err instanceof HttpErrorResponse ? err.message : err);
          // Return a no-content success to upstream subscribers
          return of(new HttpResponse({ status: 204 }));
        }
        return throwError(() => err);
      })
    );
  }
}
